exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-element-base[data-v-b3bd2892]{padding-top:10px!important}.card-element-focus[data-v-b3bd2892]{box-shadow:0 0 8px rgba(0,0,0,.7)!important;border-color:#333!important;outline:0;box-shadow:0 0 8px rgba(0,0,0,.6)!important}.card-element-small[data-v-b3bd2892]{width:80px}", ""]);

// exports
